<template>
<div class="l_important" v-if="this.__isDisplay(this.isImportant)">
  <div class="c_important__info">
    <a class="c_important__link" @click="tapLink" >
      <span class="c_important__title">{{this.title}}</span>
    </a>
  </div>
</div>
</template>

<script>
export default {
  name: 'ImportantInformation',
  props: {
    title: { type: String, required: true },
    id: { type: String, required: true },
    url: { type: String, default: '' },
    isImportant: { type: String, default: '0' }
  },
  methods: {
    /// リンクタップ
    tapLink () {
      this.$emit('click')
    },
    /**
     * 表示判定
     * @param {String} isImportant 0 or 1
     */
    __isDisplay (isImportant) {
      return isImportant === '2'
    }
  }
}
</script>

<style scoped>

.l_important + .l_important {
  margin-top: 5px;
}

.c_important__info{
  width: 100%;
  box-shadow: 0 0 1.5px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  text-align: center;
  padding: 12px;
  line-height: 1.0;
  text-align: left;
}

.c_important__link {
  text-decoration: #cc0033;
  border-bottom: 1px solid #cc0033;
}

.c_important__title {
  font-size: 12px;
  font-family: 'HiraKakuPro-W6';
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #cc0033;
}

</style>
